import axiosInstance from './axiosInstance';

const TPVS_API_URL = '/tpvs';

const tpvsService = {
  async getBulk(idempresa, environment = 'production') {
    try {
      const response = await axiosInstance.get(`${TPVS_API_URL}/get.php?idempresa=${idempresa}&environment=${environment}`);
      return response.data !== "NOK" ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter TPVs:', error);
      return [];
    }
  },
};

export default tpvsService;
